import _ from 'lodash';
import updateQuery from 'shared/helpers/updateQuery';
import { browserHistory } from 'react-router';

export function openDialog(data) {
  updateQuery(data);
}

export function closeDialog() {
  browserHistory.goBack();
}

const addZero = number => number < 10 ? `0${number}` : `${number}`;

export function createDate(date) {
  const year = date.getFullYear().toString();
  const month = addZero(date.getMonth() + 1);
  const day = addZero(date.getDate());
  const hours = addZero(date.getHours());
  const min = addZero(date.getMinutes());
  const sec = addZero(date.getSeconds());
  return [year, month, day, hours, min, sec].join('');
}

export function checkFileName(files, fileName) {
  let i = 0;
  const fileNameSplited = _.split(fileName, '.');
  if (_.size(fileNameSplited) === 1) {
    const name = fileNameSplited[0];
    while (_.findIndex(files, ['name', fileName]) !== -1) {
      i += 1;
      fileName = `${name}(${i})`;
    }
  } else {
    const fileExt = _.last(fileNameSplited);
    const name = _.join(_.dropRight(fileNameSplited), '.');
    while (_.findIndex(files, ['name', fileName]) !== -1) {
      i += 1;
      fileName = `${name}(${i}).${fileExt}`;
    }
  }
  return fileName;
}

export function getFolderAndSubFolderImages(folderObj, images = []) {
  const files = folderObj.files;
  if (!_.isEmpty(files)) {
    const filesPath = folderObj.currentFolder.path;
    _.map(files, file => images.push(filesPath + file.name));
  }
  const subFolders = folderObj.folders;
  if (subFolders && !_.isEmpty(subFolders)) {
    _.map(subFolders, subFolder => getFolderAndSubFolderImages(subFolder, images));
  }
  return images;
}

export function downloadImage(name, url) {
  const link = document.createElement('a');
  link.download = name;
  link.target = '_blank';
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
